import css from './image.module.css'

import type { ImageBorderRadius, ImageObjectFit } from './image.types.ts'

type ResolvedAspectRatio = '1/1' | '4/3' | '16/9' | '3/4' | '9/16'

export const styles = {
  base: css.image,
  dynamic: (
    aspectRatio: ResolvedAspectRatio,
    objectFit: ImageObjectFit,
    radius: ImageBorderRadius,
  ) => ({
    aspectRatio: aspectRatio.replace('/', ' / '),
    objectFit,
    borderRadius: radius === 'none' ? '0px' : `var(--border-radius-${radius})`,
  }),
}
